import { getDateWithoutTimezone } from '@ibk/shared-utils';
import { BeneficiaryStatus, BeneficiaryStatusInProduct, } from '../../../../types/voucher-beneficiaries';
export function mapEmissorBeneficiaryToVoucherBeneficiary(beneficiary) {
    const bond = beneficiary.bond;
    const kycStatus = beneficiary.kycStatus ?? null;
    const identityStatus = beneficiary.identityStatus ?? null;
    return {
        id: beneficiary.id,
        jobRole: bond?.jobRole ?? null,
        document: beneficiary.document,
        firstName: beneficiary.firstName,
        lastName: beneficiary.lastName,
        employeeCode: bond?.employeeCode ?? '',
        deliveryLocationId: '',
        birthDate: beneficiary.birthDate ? getDateWithoutTimezone(beneficiary.birthDate) : new Date(0),
        phoneNumber: '',
        email: bond?.email ?? '',
        status: beneficiary.isWorking ? BeneficiaryStatus.WORKING : BeneficiaryStatus.INACTIVE,
        employeeId: bond?.employeeId ?? '',
        isNew: false,
        productValue: 0,
        statusInProduct: beneficiary.statusInProduct === BeneficiaryStatusInProduct.ACTIVE
            ? BeneficiaryStatusInProduct.ACTIVE
            : BeneficiaryStatusInProduct.INACTIVE,
        productDaysQuantity: 0,
        productDiscountValue: 0,
        kycStatus,
        identityStatus,
        kycErrors: beneficiary.kycErrors ?? null,
        identityErrors: beneficiary.identityErrors ?? null,
        cardIssued: beneficiary.cardIssued,
        contractType: bond?.contractType ?? undefined,
        costCenter: bond?.costCenter ?? undefined,
        department: bond?.department ?? undefined,
        category: bond?.category ?? undefined,
        employmentBond: bond?.employmentBond ?? undefined,
        branch: bond?.branch ?? undefined,
        union: bond?.union ?? undefined,
        hireDate: bond?.hireDate ?? null,
    };
}
export function mapEmissorBeneficiariesToVoucherBeneficiaries(beneficiaries) {
    return beneficiaries.map(mapEmissorBeneficiaryToVoucherBeneficiary);
}
export function mapFilterDataToEmissorSearchBody(filters) {
    if (!filters) {
        return {};
    }
    const arrayOrUndefined = (values) => (values && values.length > 0 ? values : undefined);
    return {
        name: filters.name?.trim() ? filters.name.trim() : undefined,
        contractType: arrayOrUndefined(filters.contractType),
        jobRole: arrayOrUndefined(filters.jobRole),
        costCenter: arrayOrUndefined(filters.costCenter),
        department: arrayOrUndefined(filters.department),
        category: arrayOrUndefined(filters.category),
        employmentBond: arrayOrUndefined(filters.employmentBond),
        branch: arrayOrUndefined(filters.branch),
        union: arrayOrUndefined(filters.union),
    };
}
